import { ACTIVE_CHIP_CLASS_NAME, STATUS_FILTERS } from "../constants";
import { StatusFilterKey } from "../types";

interface StatusChipsProps {
  value: StatusFilterKey;
  counts: Record<StatusFilterKey, number>;
  onChange: (key: StatusFilterKey) => void;
}

export function StatusChips({
  value,
  counts,
  onChange,
}: StatusChipsProps): JSX.Element {
  return (
    <div className="flex flex-wrap gap-2">
      {STATUS_FILTERS.map((filter) => (
        <button
          key={filter.key}
          type="button"
          aria-pressed={value === filter.key}
          onClick={() => onChange(filter.key)}
          className={`rounded-full border px-3 py-1 text-xs font-medium transition-colors focus-visible:outline focus-visible:outline-2 focus-visible:outline-[#613F4F] ${
            value === filter.key
              ? ACTIVE_CHIP_CLASS_NAME
              : filter.inactiveClassName
          }`}
        >
          {filter.label} ({counts[filter.key] ?? 0})
        </button>
      ))}
    </div>
  );
}
